


export abstract class FRDataRetriever{
    static GlobalFunctions:Map<string,any>=new Map();
    public VarDictionary:Map<String,any>;
    public FunctionDictionary:Map<string,any>;

    constructor() {
        this.VarDictionary=new Map<String, any>();
        this.FunctionDictionary=FRDataRetriever.GlobalFunctions;
    }

    public abstract GetFieldById(id:string):any;

    SetVar(varName:string,value:any) {
        this.VarDictionary.set(varName,value);
    }

    GetVar(varName:string) {
        if(!this.VarDictionary.has(varName))
            return null;
        return this.VarDictionary.get(varName);
    }

    public AddFunction(functionName:string,functionObj:(retriever?:FRDataRetriever,...args:any)=>any)
    {
        this.FunctionDictionary.set(functionName,functionObj);
    }

    CallFunction(functionName:string,args:any[])
    {
        if(!this.FunctionDictionary.has(functionName))
            return null;

        args=[this,...args];
        return this.FunctionDictionary.get(functionName).apply(null,args);

    }

}